module.exports = {
  apiBaseProd: 'http://restapi.xuanwonainiu.com',
  apiCms: 'http://qf-bos.xuanwonainiu.com',
  apiNode: 'http://api.ab1a.cn',
  apiNodeNew: 'http://apiyhact.ab1a.cn',
  apiNodeOld: 'http://apiouer.ab1a.cn',
  siteName: '',
}